import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: "app-choose-date-dialog",
  templateUrl: "./choose-date-dialog.component.html",
  styleUrls: ["./choose-date-dialog.component.css"]
})
export class ChooseDateDialogComponent implements OnInit {
  public title = "Select Date";
  public text = "Please choose a date.";
  public confirm = "Confirm";
  public cancel = "Cancel";
  public selectedDate: Date | null = null;
  public minDate: Date | null = null;
  public maxDate: Date | null = null;

  constructor(
    public dialogRef: MatDialogRef<ChooseDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title || this.title;
      this.text = this.data.text || this.text;
      this.cancel = this.data.cancel || this.cancel;
      this.confirm = this.data.confirm || this.confirm;
      this.minDate = this.data.minDate ? new Date(this.data.minDate) : null;
      this.maxDate = this.data.maxDate ? new Date(this.data.maxDate) : null;
    }
  }

  onConfirmClick(): void {

    console.log(this.selectedDate);

    this.dialogRef.close(new Date(this.selectedDate));
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
